import React, { useEffect, useState, useRef } from "react";
import { secretKey } from "../.././data";
import LoadingPopup from "../helpers/loading_component.js";
import { faEdit, faEye, faDeleteLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal2);

const AdminPanelLoopTasks = (props) => {
  const [banks, setBanks] = useState([]);
  const [groups, setGroups] = useState([]);
  const [group, setGroup] = useState("");
  const [actual, setActual] = useState([]);
  const [users, setUsers] = useState([]);
  const [types, setTypes] = useState([]);
  const [switchF, setSwitchF] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchResults = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getTaskLoop", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setBanks(data);
        fetchTypes();
      })
      .catch((error) => {});
  };

  const fetchTypes = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getTaskTypes", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTypes(data);
        fetchGroups();
      })
      .catch((error) => {});
  };

  const fetchGroups = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getTaskLoopGroups", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setGroups(
          data.sort(function (a, b) {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          })
        );
        if (data.length > 0 && group.length === 0) {
          setGroup(
            data.sort(function (a, b) {
              if (a.name < b.name) {
                return -1;
              }
              if (a.name > b.name) {
                return 1;
              }
              return 0;
            })[0].name
          );
        }

        fetchSwitch();
      })
      .catch((error) => {});
  };

  const fetchSwitch = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getTaskLoopSwitch", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSwitchF(data);
        fetchResults2();
      })
      .catch((error) => {});
  };

  const fetchResults2 = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getTaskLoopActual", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setActual(data);
        fetchUsers();
      })
      .catch((error) => {});
  };

  const fetchUsers = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    setGroup("");
    fetchResults();
  };

  useEffect(() => {
    getData();
  }, []);

  const changeTableText = (e) => {
    var field = e.currentTarget.attributes.field.value;
    var userId = e.currentTarget.attributes.fieldUID.value;
    var table = "taskLoop";

    MySwal.fire({
      title: "Wprowadź nową wartość",
      text: e.currentTarget.attributes.desc.value,
      input: "text",
      inputPlaceholder: e.currentTarget.value,
      value: e.currentTarget.value,
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz podać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var value = result.value;

        var body = {
          field: field,
          value: value,
          id: userId,
          table: table,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateConfigTable", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const changeTableTextUsers = (e) => {
    var field = e.currentTarget.attributes.field.value;
    var userId = e.currentTarget.attributes.fieldUID.value;
    var table = "taskLoop";

    var model = [];
    users.map((el) => {
      model[el.name] = el.name;
    });

    MySwal.fire({
      title: "Wybierz wartość",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var value = result.value;

        var body = {
          field: field,
          value: value,
          id: userId,
          table: table,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateConfigTable", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const changeConfigRow = async (e) => {
    var userId = e.currentTarget.attributes.fieldUID.value;
    var table = "taskLoop";

    var body = {
      id: userId,
      table: table,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteConfigTable", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        getData();
      })
      .catch((error) => {});
  };

  const insertConfigRow = async (e) => {
    var table = "taskLoop";

    var model = [];
    users.map((el) => {
      model[el.name] = el.name;
    });

    MySwal.fire({
      title: "Wybierz wartość",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var value = result.value;

        var body = {
          table: table,
          group: group,
          name: value,
        };

        await fetch(
          "https://apidevkppp.ftpeople.pl/insertConfigTableTaskLoop",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          }
        )
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const usersTableFirst = (
    <table id="detailClientTable" className="clients_table">
      <tr>
        <th>Lp.</th>
        <th>Nazwa</th>
        <th>Akcja</th>
      </tr>
      {banks
        .filter((eq) => eq.groupA === group)
        .map((el, index) => (
          <>
            <tr>
              <td
                style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}
              >
                {index + 1}
              </td>
              <td
                style={{ width: "15%", textAlign: "left", paddingLeft: "10px" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {el.name}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  >
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="sign_aggr"
                      desc={""}
                      value={el.name}
                      fieldUID={el.id}
                      field="name"
                      onClick={changeTableTextUsers}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </div>
                </div>
              </td>

              <td
                style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
              >
                <button
                  style={{
                    marginLeft: "10px",
                    width: "10%",
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "1vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="sign_aggr"
                  desc={""}
                  value={el.name}
                  fieldUID={el.id}
                  field="team"
                  onClick={changeConfigRow}
                >
                  <FontAwesomeIcon icon={faDeleteLeft} />
                </button>
              </td>
            </tr>
          </>
        ))}
    </table>
  );

  const usersTableSecond = (
    <table id="detailClientTable" className="clients_table">
      <tr>
        <th>Lp.</th>
        <th>Nazwa</th>

        <th>Limit</th>
      </tr>
      {actual
        .filter((eq) => eq.groupA === group)
        .map((el, index) => (
          <>
            <tr>
              <td
                style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}
              >
                {index + 1}
              </td>
              <td
                style={{ width: "15%", textAlign: "left", paddingLeft: "10px" }}
              >
                {el.name}
              </td>
            </tr>
          </>
        ))}
    </table>
  );

  const addGroup = (e) => {
    MySwal.fire({
      title: "Wprowadź nową wartość",
      text: "",
      input: "text",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz podać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var value = result.value;

        var body = {
          name: value,
        };

        await fetch("https://apidevkppp.ftpeople.pl/addTaskLoopGroup", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const deleteGroup = async (e) => {
    var body = {
      name: group,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteTaskLoopGroup", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        getData();
      })
      .catch((error) => {});
  };

  const editGroup = async (e) => {
    MySwal.fire({
      title: "Wprowadź nową wartość",
      text: "",
      input: "text",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz podać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var value = result.value;

        var body = {
          name: value,
          old: group,
          id: groups.filter((e) => e.name === group)[0].id,
        };

        await fetch("https://apidevkppp.ftpeople.pl/editTaskLoopGroup", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const usersTableThird = (
    <>
      <div>
        <select
          style={{ width: "25vw", height: "3vh" }}
          value={group}
          onChange={(e) => {
            setGroup(e.target.value);
          }}
        >
          {group === "" ? (
            <>
              <option key={"qwe"}>Wybierz...</option>
            </>
          ) : (
            ""
          )}
          {groups.map((e) => (
            <option key={e.name} value={e.name}>
              {e.name}
            </option>
          ))}
        </select>
      </div>
      <div style={{ display: "flex", gap: "10px" }}>
        <button
          style={{ marginTop: "2vh", backgroundColor: "green" }}
          className="closeClientButton"
          onClick={addGroup}
        >
          DODAJ GRUPĘ
        </button>
        {group ? (
          <>
            <button
              style={{
                marginTop: "2vh",
                backgroundColor: "yellow",
                color: "black",
              }}
              className="closeClientButton"
              onClick={editGroup}
            >
              ZMIEŃ NAZWĘ
            </button>
            <button
              style={{ marginTop: "2vh", backgroundColor: "red" }}
              className="closeClientButton"
              onClick={deleteGroup}
            >
              USUŃ GRUPĘ
            </button>
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );

  return (
    <>
      <div className="mainContainerPayments">
        {loading ? (
          <>
            <LoadingPopup />
          </>
        ) : (
          <>
            <div
              style={{ width: "100%", marginBottom: "1vh" }}
              className="closeBox"
            >
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>
            <div
              style={{
                height: "5vh",
                fontSize: "2vw",
                fontWeight: "600",
                paddingBottom: "2vh",
              }}
            >
              Grupy wsparcia działu prawnego - zadania
            </div>

            {usersTableThird}

            <div style={{ paddingBottom: "2vh" }}></div>
            {usersTableFirst}

            <button
              style={{ marginTop: "2vh", backgroundColor: "green" }}
              className="closeClientButton"
              onClick={insertConfigRow}
            >
              DODAJ
            </button>

            {group === "" ? (
              <> </>
            ) : (
              <>
                <div
                  style={{
                    height: "5vh",
                    fontSize: "2vw",
                    fontWeight: "600",
                    paddingBottom: "2vh",
                    paddingTop: "2vh",
                  }}
                >
                  Zadania w grupie
                </div>
                <table id="detailClientTable" className="clients_table">
                  <tr>
                    <th>Lp.</th>
                    <th>Nazwa</th>
                    <th>Waga</th>
                  </tr>
                  {types
                    .filter((eq) => eq.groupX === group)
                    .map((el, index) => (
                      <>
                        <tr>
                          <td
                            style={{
                              width: "2%",
                              textAlign: "center",
                              paddingLeft: "0",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              width: "15%",
                              textAlign: "left",
                              paddingLeft: "10px",
                            }}
                          >
                            {el.name}
                          </td>
                          <td
                            style={{
                              width: "15%",
                              textAlign: "left",
                              paddingLeft: "10px",
                            }}
                          >
                            {el.weight}
                          </td>
                        </tr>
                      </>
                    ))}
                </table>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AdminPanelLoopTasks;
